import { useState } from "react";

export default function NewsletterSection() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<"idle" | "success" | "error">("idle");
  const [formError, setFormError] = useState("");
  const formUrl = "https://readdy.ai/api/form/d9spdh94ne17ei0sdllg";

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypotVal = (formData.get("website_alt") as string || "").trim();
    if (honeypotVal) {
      setStatus("success");
      return;
    }

    if (!email.trim()) {
      setFormError("请输入您的邮箱地址");
      setStatus("error");
      return;
    }

    try {
      const res = await fetch(formUrl, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({ email }).toString(),
      });
      const text = await res.text();
      let parsed: any = {};
      try { parsed = JSON.parse(text); } catch { /* ignore */ }
      if (res.ok && parsed?.code === "OK") {
        setStatus("success");
        setEmail("");
      } else {
        setFormError(parsed?.meta?.message || parsed?.message || "订阅失败，请稍后重试");
        setStatus("error");
      }
    } catch {
      setFormError("网络错误，请检查连接后重试");
      setStatus("error");
    }
  };

  return (
    <section className="py-14 md:py-20 bg-accent-100">
      <div className="max-w-2xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3" style={{ fontFamily: "var(--font-heading)" }}>
          订阅牛奶片库资讯
        </h2>
        <p className="text-sm md:text-base text-foreground-600 mb-8">
          每周推送最新牛奶片评测、选购指南和优惠信息，不错过任何好产品
        </p>

        <form
          onSubmit={handleSubmit}
          className="flex flex-col sm:flex-row items-center gap-3 max-w-md mx-auto"
          data-readdy-form=""
        >
          <div className="relative w-full">
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => { setEmail(e.target.value); setStatus("idle"); setFormError(""); }}
              placeholder="请输入您的邮箱地址"
              className="w-full px-4 py-3 text-sm rounded-full border border-background-300 bg-background-50 text-foreground-900 placeholder-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
              required
            />
          </div>
          <input
            type="text"
            name="website_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
            className="website_alt_field"
          />
          <button
            type="submit"
            className="w-full sm:w-auto px-8 py-3 bg-primary-500 text-background-50 font-medium rounded-full text-sm whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
          >
            立即订阅
          </button>
        </form>

        {status === "success" && (
          <p className="mt-4 text-sm text-green-600">
            <i className="ri-check-line mr-1"></i>订阅成功！感谢您的关注
          </p>
        )}
        {status === "error" && formError && (
          <p className="mt-4 text-sm text-red-500">
            <i className="ri-error-warning-line mr-1"></i>{formError}
          </p>
        )}
      </div>
    </section>
  );
}